import React from "react";

export interface IBannerData<T> {
  type?: T;
  size: number;
  row: number;
  column: number;
  // The pagination component requires a consistent page count for a
  // given usage. Thus, if the banner is not to be shown on every page,
  // then this needs to be true for pagination to remain functional.
  useStandardPageSize?: boolean;
  component?: React.ReactElement;
  // banner will take the entire row
  fullRowBanner?: boolean;
  // if banner row position is relative to product,
  // we'll adjust row number based number of fullRowBanner above it
  rowNumberRelativeToProductRow?: boolean;
  // handle the case when a banner can be displayed as modal or banner
  // e.g. apparel style quiz banner has format of both modal and banner
  renderAsModal?: boolean;
}

export namespace IBannerData {
  export const build = <T>(
    partial?: Partial<IBannerData<T>> | undefined
  ): IBannerData<T> => ({
    size: 0,
    row: 0,
    column: 0,
    ...(partial ?? {}),
  });
}

export const sortBanner = (
  bannerA: IBannerData<unknown>,
  bannerB: IBannerData<unknown>
): number => bannerA.row - bannerB.row || bannerA.column - bannerB.column;

export const withBanner = <T>(
  items: T[],
  itemsPerRow: number,
  bannerData: IBannerData<unknown>[]
) => {
  const itemsWithFakeTiles = [...items];
  const fakeTile = { fake: true } as unknown as T;
  const sortedBannerData = bannerData.sort(sortBanner);
  sortedBannerData.forEach((banner) => {
    if (banner.renderAsModal) {
      return;
    }
    const rowToInsert = banner.row - 1;
    const columnToInsert = banner.column - 1;
    const indexToInsert = rowToInsert * itemsPerRow + columnToInsert;
    for (let i = 0; i < banner.size; i++) {
      itemsWithFakeTiles.splice(indexToInsert, 0, fakeTile);
    }
  });

  return itemsWithFakeTiles;
};
